export type CardsLayoutType =
  | 'Contacts'
  | 'Rattachements'
  | 'Tâches'
  | 'Actualités'
  | 'Brouillons'
  | 'Dossiers'
  | 'Factures'
  | 'Virements'

export type CardsLayoutProps = {
  cardsType: CardsLayoutType
  cards?: CardProps[]
  selectionnable?: boolean
  headerText?: string
  hasHeader?: boolean
  redirection?: () => void
}

const TACHES_VIDE_TEXT = "Vous n'avez pas de tâches à traiter"
const CONTACTS_VIDE_TEXT = 'Aucun contact n’a été ajouté à votre profil'
const RATTACHEMENTS_VIDE_TEXT = 'Vous n’êtes rattaché à aucun établissement'
const ACTUALITES_VIDE_TEXT = "Pas d'actualités pour le moment"
const BROUILLONS_VIDE_TEXT = 'Aucun brouillon pour le moment'
const DOSSIERS_VIDE_TEXT = 'Aucun dossier pour le moment'
const FACTURES_VIDE_TEXT = 'Aucune facture pour le moment'
const VIREMENTS_VIDE_TEXT = 'Aucun virement pour le moment'

import { useDemandeRattachement } from '@/features/interface/profil-utilisateur/rattachements/demande'
const demandeRattachement = () => {
  const demande = useDemandeRattachement()
  demande.showDialog()
}

type EmptyCardConfig = {
  emptyCardLibelle: string
  emptyCardRedirection?: () => void
}

export const labelMapping: Record<CardsLayoutType, EmptyCardConfig> = {
  Tâches: {
    emptyCardLibelle: TACHES_VIDE_TEXT,
  },
  Rattachements: {
    emptyCardLibelle: RATTACHEMENTS_VIDE_TEXT,
    emptyCardRedirection: demandeRattachement,
  },
  Contacts: {
    emptyCardLibelle: CONTACTS_VIDE_TEXT,
  },
  Actualités: {
    emptyCardLibelle: ACTUALITES_VIDE_TEXT,
  },
  Brouillons: {
    emptyCardLibelle: BROUILLONS_VIDE_TEXT,
  },
  Dossiers: {
    emptyCardLibelle: DOSSIERS_VIDE_TEXT,
  },
  Factures: {
    emptyCardLibelle: FACTURES_VIDE_TEXT,
  },
  Virements: {
    emptyCardLibelle: VIREMENTS_VIDE_TEXT,
  },
}
